const PlayerFullName = ({ fullName }) => {
  return (
    <>
      <p className="text-xs sm:text-base w-36 sm:w-56 md:w-56 lg:w-56 xl:w-56 2xl:w-56 text-ellipsis truncate">
        {fullName}
      </p>
    </>
  );
};

export default PlayerFullName;
